import * as React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const PlaceholderLoader = (props) => {
    return (React.createElement(Loader, { style: {
            width: props.width || '100%',
            height: props.height || '25px',
            display: props.inline ? 'inline-block' : null,
            ...props.style,
        } }));
};
export default PlaceholderLoader;
const Loader = styled.div `
  display: inline-block;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${THEME.SURFACE_MUTED};
  background: linear-gradient(
    to right,
    ${THEME.SURFACE_MUTED} 8%,
    ${THEME.FILL} 18%,
    ${THEME.SURFACE_MUTED} 33%
  );
  background-size: 800px 104px;
  position: relative;

  @keyframes placeHolderShimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }
`;
//# sourceMappingURL=PlaceholderLoader.js.map